up.compiler('[readonly-checkboxes]', (element) => {
  up.on(element, 'change', 'input[type="checkbox"]', (event) => {
    event.target.checked = !event.target.checked
  })
})
